import * as React from 'react';

import { DeviceInfoContext } from '@/contexts/device-info-context';

function AirBaloonIcon(props) {
  const { isMobile } = React.useContext(DeviceInfoContext);

  return isMobile ? (
    <svg width={30} height={36} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M20.92 24.041a1.049 1.049 0 01-.22-1.495l6.577-8.547 1.534-.214.22 1.495-6.577 8.547a1.113 1.113 0 01-1.534.214z'
        fill='url(#prefix__paint0_linear_211_202)'
      />
      <path
        d='M7.547 23.827L.97 15.28l.22-1.495 1.533.214L9.3 22.546a1.049 1.049 0 01-.22 1.495 1.113 1.113 0 01-1.533-.214z'
        fill='url(#prefix__paint1_linear_211_202)'
      />
      <path
        d='M15 24.255c-.605 0-1.096-.478-1.096-1.069V14.64c0-.59.49-1.068 1.097-1.068.605 0 1.096.478 1.096 1.068v8.547c0 .591-.49 1.069-1.097 1.069z'
        fill='url(#prefix__paint2_linear_211_202)'
      />
      <g filter='url(#prefix__filter0_bi_211_202)'>
        <rect x={6.256} y={21.45} width={17.305} height={13.8} rx={4} fill='#72BF44' fillOpacity={0.5} />
      </g>
      <path
        d='M.75 14.64C.75 6.98 7.143.75 15 .75s14.25 6.231 14.25 13.89c0 .813-.897 1.324-1.623.936-.68-.362-2.03-.937-2.762-.937-.764 0-2.19.632-2.76.936a1.117 1.117 0 01-1.055.001c-.68-.362-2.03-.937-2.762-.937-.764 0-2.19.632-2.76.936a1.117 1.117 0 01-1.055.001c-.68-.362-2.03-.937-2.762-.937-.764 0-2.19.632-2.76.936a1.117 1.117 0 01-1.055.001c-.68-.362-2.03-.937-2.761-.937-.765 0-2.19.632-2.761.936-.725.39-1.624-.122-1.624-.936z'
        fill='url(#prefix__paint3_linear_211_202)'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_211_202'
          x1={20.48}
          y1={13.785}
          x2={27.969}
          y2={13.074}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear_211_202'
          x1={0.97}
          y1={13.785}
          x2={8.458}
          y2={13.074}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <linearGradient
          id='prefix__paint2_linear_211_202'
          x1={13.904}
          y1={13.571}
          x2={15.841}
          y2={13.525}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <linearGradient
          id='prefix__paint3_linear_211_202'
          x1={0.75}
          y1={0.75}
          x2={24.76}
          y2={-4.567}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_211_202'
          x={2.256}
          y={17.45}
          width={25.305}
          height={21.8}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_202' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_202' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_211_202' />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg width={44} height={52} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M30.88 35.062a1.573 1.573 0 01-.33-2.243l9.866-12.82 2.3-.322.33 2.243-9.866 12.82a1.67 1.67 0 01-2.3.322z'
        fill='url(#prefix__paint0_linear_159_5589)'
      />
      <path
        d='M10.82 34.74L.954 21.92l.33-2.243 2.3.321L13.45 32.82a1.573 1.573 0 01-.33 2.243 1.67 1.67 0 01-2.3-.321z'
        fill='url(#prefix__paint1_linear_159_5589)'
      />
      <path
        d='M22 35.383c-.91 0-1.645-.717-1.645-1.603V20.96c0-.887.736-1.604 1.645-1.604s1.644.717 1.644 1.603V33.78c0 .886-.735 1.603-1.644 1.603z'
        fill='url(#prefix__paint2_linear_159_5589)'
      />
      <g filter='url(#prefix__filter0_bi_159_5589)'>
        <rect x={8.884} y={31.175} width={25.957} height={20.7} rx={4} fill='#72BF44' fillOpacity={0.5} />
      </g>
      <path
        d='M.625 20.959C.625 9.471 10.215.125 22 .125c11.786 0 21.375 9.346 21.375 20.834 0 1.22-1.345 1.987-2.434 1.405-1.02-.543-3.045-1.405-4.143-1.405-1.146 0-3.285.947-4.141 1.404a1.675 1.675 0 01-1.582.002c-1.02-.544-3.044-1.406-4.142-1.406-1.147 0-3.286.947-4.141 1.404a1.675 1.675 0 01-1.582.002c-1.02-.544-3.044-1.406-4.143-1.406-1.146 0-3.285.947-4.14 1.404a1.675 1.675 0 01-1.582.002c-1.02-.544-3.045-1.406-4.143-1.406-1.147 0-3.285.947-4.141 1.404-1.088.585-2.436-.184-2.436-1.404z'
        fill='url(#prefix__paint3_linear_159_5589)'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_159_5589'
          x1={30.221}
          y1={19.677}
          x2={41.454}
          y2={18.611}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear_159_5589'
          x1={0.954}
          y1={19.677}
          x2={12.187}
          y2={18.611}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <linearGradient
          id='prefix__paint2_linear_159_5589'
          x1={20.355}
          y1={19.356}
          x2={23.26}
          y2={19.287}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <linearGradient
          id='prefix__paint3_linear_159_5589'
          x1={0.625}
          y1={0.125}
          x2={36.639}
          y2={-7.851}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_159_5589'
          x={4.884}
          y={27.175}
          width={33.957}
          height={28.7}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_159_5589' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_159_5589' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_159_5589' />
        </filter>
      </defs>
    </svg>
  );
}

export default AirBaloonIcon;
